import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black/50 backdrop-blur-lg border-t border-white/10 py-12 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="font-playfair text-2xl font-bold text-gold mb-4">
              Kingdom Wealth Financial
            </h3>
            <p className="font-manrope text-white/70 text-sm leading-relaxed">
              Empowering business growth across USA and Canada with comprehensive funding solutions.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-manrope text-white font-semibold mb-4">
              Contact Us
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <p className="font-manrope text-white/70 text-sm">
                  59 Lewiston Street, Boston, MA 02136
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-gold flex-shrink-0" />
                <a
                  href="tel:+17132564527"
                  className="font-manrope text-white/70 text-sm hover:text-gold transition-colors duration-300"
                >
                  +1 (713) 256-4527
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-gold flex-shrink-0" />
                <a
                  href="mailto:info@kingdomwealthfinancial.com"
                  className="font-manrope text-white/70 text-sm hover:text-gold transition-colors duration-300"
                >
                  info@kingdomwealthfinancial.com
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-manrope text-white font-semibold mb-4">
              Our Services
            </h4>
            <ul className="space-y-2">
              <li className="font-manrope text-white/70 text-sm">Business Funding</li>
              <li className="font-manrope text-white/70 text-sm">Real Estate Financing</li>
              <li className="font-manrope text-white/70 text-sm">Personal Loans</li>
              <li className="font-manrope text-white/70 text-sm">Credit Repair Services</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="font-manrope text-white/50 text-sm">
            © {new Date().getFullYear()} Kingdom Wealth Financial. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}